import { BehaviorSubject } from 'rxjs';
import { logTaskModuleUserAction } from './utilities/logTaskModuleUserAction';
const taskModuleDialogInfoEmitter = new BehaviorSubject(null);
export const observeTaskModule = () => {
    return taskModuleDialogInfoEmitter.asObservable();
};
export const showTaskModule = (taskModuleManifest) => {
    logTaskModuleUserAction('Click', 'Show_Task_Module_Dialog', 'Open', taskModuleManifest.taskInfo.type === 'card'
        ? 'ADAPTIVECARD'
        : taskModuleManifest.dialogType, taskModuleManifest.appId);
    taskModuleDialogInfoEmitter.next(taskModuleManifest);
    return taskModuleManifest === null || taskModuleManifest === void 0 ? void 0 : taskModuleManifest.submitHandler;
};
export const submitTaskModule = () => {
    logTaskModuleUserAction('Click', 'Submit_Task_Module_Dialog', 'Submit');
    taskModuleDialogInfoEmitter.next(null);
};
//# sourceMappingURL=TaskModuleFunctions.js.map